import { defineMessages } from 'react-intl-next';

export const messages: {
	headerWork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headerStatus: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headerAssignee: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headerPriority: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	smartlinkCardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorMessageWithViewAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unassigned: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllNoCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	close: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapse: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hide: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unhide: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	headerWork: {
		id: 'search_ai.jira_nl_to_jql_card.table_header.work',
		defaultMessage: 'Work',
		description: 'Table header for the work column',
	},
	headerStatus: {
		id: 'search_ai.jira_nl_to_jql_card.table_header.status',
		defaultMessage: 'Status',
		description: 'Table header for the status column',
	},
	headerAssignee: {
		id: 'search_ai.jira_nl_to_jql_card.table_header.assignee',
		defaultMessage: 'Assignee',
		description: 'Table header for the assignee column',
	},
	headerPriority: {
		id: 'search_ai.jira_nl_to_jql_card.table_header.priority',
		defaultMessage: 'Priority',
		description: 'Table header for the priority column',
	},
	cardTitle: {
		id: 'search_ai.jira_nl_to_jql_card.card.title',
		defaultMessage: 'Top Jira work items',
		description: 'Jira card title',
	},
	smartlinkCardTitle: {
		id: 'search_ai.jira_nl_to_jql_smartlink_card.card.title',
		defaultMessage: 'Answer',
		description: 'Smartlink Jira NL to JQL card title',
	},
	errorMessage: {
		id: 'search_ai.jira_nl_to_jql_card.error',
		defaultMessage: 'Rovo couldn\'t generate an answer for "{title}". Try rephrasing your query.',
		description: 'Error message when failing to get Jira work items',
	},
	errorMessageWithViewAll: {
		id: 'search_ai.jira_nl_to_jql_error_card.error_with_view_all',
		defaultMessage:
			'Rovo couldn\'t generate an answer for "{query}". Try rephrasing your query or navigate to Jira work items to reformulate your query.',
		description:
			'Error message when failing to get Jira work items, with suggestion to view all work items',
	},
	noResultsMessage: {
		id: 'search_ai.jira_nl_to_jql_card.no_results',
		defaultMessage: 'No results found',
		description: 'No results message when no Jira work items are found',
	},
	unassigned: {
		id: 'search_ai.jira_nl_to_jql_card.unassigned',
		defaultMessage: 'Unassigned',
		description: 'Label for an Unassigned work item',
	},
	viewAll: {
		id: 'search_ai.jira_nl_to_jql_card.viewall',
		defaultMessage:
			'{totalCount, plural, one {View {totalCount, number} work item} other {View all {totalCount, number} work items}}',
		description: 'Label for the view all button.',
	},
	viewAllNoCount: {
		id: 'search_ai.jira_nl_to_jql_card.viewall_no_count',
		defaultMessage: 'View all work items',
		description: 'Label for the view all button when total count is unknown.',
	},
	close: {
		id: 'search_ai.jira_nl_to_jql_card.close',
		defaultMessage: 'Close',
		description: 'Label for the close button on the error card.',
	},
	expand: {
		id: 'search_ai.jira_nl_to_jql_card.expand',
		defaultMessage: 'Expand table',
		description:
			'Label for the expand button that increases the table height to show more Jira work items in the card.',
	},
	collapse: {
		id: 'search_ai.jira_nl_to_jql_card.collapse',
		defaultMessage: 'Collapse table',
		description:
			'Label for the collapse button that decreases the table height to show fewer Jira work items in the card.',
	},
	dismiss: {
		id: 'search_ai.jira_nl_to_jql_card.dismiss',
		defaultMessage: 'Dismiss',
		description:
			'Label for the dismiss button that hides the Jira NL to JQL card from the current view.',
	},
	hide: {
		id: 'search_ai.jira_nl_to_jql_card.hide',
		defaultMessage: 'Hide table',
		description:
			'Label for the hide button that collapses the Jira NL to JQL card to show only the header.',
	},
	unhide: {
		id: 'search_ai.jira_nl_to_jql_card.unhide',
		defaultMessage: 'Show table',
		description:
			'Label for the unhide button that expands the Jira NL to JQL card to show full content.',
	},
});
